import { render, staticRenderFns } from "./PagamentoDocumentoForm.vue?vue&type=template&id=40cc108a"
import script from "./PagamentoDocumentoForm.vue?vue&type=script&lang=js"
export * from "./PagamentoDocumentoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports